// Policy text content for both languages
export const POLICIES_TEXT = {
  warrantyPolicy: {
    vi: {
      title: 'Chính sách bảo hành',
      description: 'Fitta cam kết bảo hành sản phẩm nhằm đảm bảo quyền lợi khách hàng đối với các lỗi phát sinh từ kết cấu, kỹ thuật và sản xuất trong điều kiện sử dụng bình thường, đúng công năng và đúng hướng dẫn sử dụng. Chính sách bảo hành này áp dụng cho tất cả sản phẩm do Fitta cung cấp.',
    },
    en: {
      title: 'Warranty Policy',
      description: 'Fitta is committed to providing product warranties to protect customer rights against defects arising from structure, technical issues, and manufacturing under normal conditions of use, proper functionality, and adherence to usage instructions. This warranty policy applies to all products provided by Fitta.',
    },
  },
  salesPolicy: {
    vi: {
      title: 'Chính sách bán hàng',
      description: 'Chính sách bán hàng của Fitta được xây dựng để đảm bảo quyền lợi của khách hàng và tạo mối quan hệ tin tưởng lâu dài.',
    },
    en: {
      title: 'Sales Policy',
      description: 'Fitta\'s sales policy is designed to protect customer rights and establish long-term trust relationships.',
    },
  },
  termsOfUse: {
    vi: {
      title: 'Điều Khoản Sử Dụng Web-App',
      description: 'Các điều khoản này quy định việc sử dụng Web App thiết kế nội thất của Fitta. Khi truy cập, sử dụng Web App hoặc thực hiện thiết kế và đặt hàng thông qua hệ thống, người dùng được xem là đã đọc, hiểu và đồng ý tuân thủ các điều khoản dưới đây.',
      section1: {
        title: '1. Giới thiệu Web-App',
        content: 'Web App của Fitta là công cụ trực tuyến cho phép người dùng:',
        items: [
          'Thiết kế và cấu hình sản phẩm nội thất',
          'Tùy chỉnh kích thước, module và vật liệu',
          'Mô phỏng bố trí sản phẩm trong không gian',
          'Tạo đơn hàng sản xuất theo thiết kế.'
        ],
        footer: 'Web App được cung cấp nhằm hỗ trợ khách hàng tham khảo và cá nhân hóa sản phẩm theo nhu cầu.',
      },
      section2: {
        title: '2. Phạm vi sử dụng',
        permitted: 'Người dùng được phép sử dụng Web App để:',
        permittedItems: [
          'Thiết kế sản phẩm cho mục đích cá nhân',
          'Tham khảo cấu hình nội thất',
          'Tạo đơn hàng với Fitta.',
        ],
        notPermitted: 'Người dùng không được phép:',
        notPermittedItems: [
          'Sao chép hoặc khai thác hệ thống cho mục đích thương mại trái phép',
          'Sao chép phần mềm hoặc giao diện hệ thống',
          'Sử dụng Web App để phát triển sản phẩm cạnh tranh.',
        ],
      },
      section3: {
        title: '3. Tài khoản người dùng',
        content: 'Trong một số trường hợp, người dùng có thể cần tạo tài khoản để lưu thiết kế hoặc đặt hàng.',
        responsible: 'Người dùng chịu trách nhiệm:',
        responsibleItems: [
          'Bảo mật thông tin tài khoản',
          'Đảm bảo tính chính xác của thông tin cung cấp',
          'Mọi hoạt động phát sinh từ tài khoản của mình',
        ],
        footer: 'Fitta có quyền tạm ngưng hoặc chấm dứt tài khoản nếu phát hiện hành vi vi phạm điều khoản.',
      },
    },
    en: {
      title: 'Web-App Terms of Use',
      description: 'These terms regulate the use of Fitta\'s Web App for interior design. When accessing, using the Web App, or performing design and ordering through the system, users are deemed to have read, understood, and agreed to comply with the terms below.',
      section1: {
        title: '1. Web-App Introduction',
        content: 'Fitta\'s Web App is an online tool that allows users to:',
        items: [
          'Design and configure interior products',
          'Customize dimensions, modules, and materials',
          'Simulate product layout in space',
          'Create manufacturing orders according to design.',
        ],
        footer: 'The Web App is provided to assist customers in reviewing and personalizing products according to their needs.',
      },
      section2: {
        title: '2. Scope of Use',
        permitted: 'Users are permitted to use the Web App for:',
        permittedItems: [
          'Designing products for personal purposes',
          'Referencing interior configurations',
          'Creating orders with Fitta.',
        ],
        notPermitted: 'Users are not permitted to:',
        notPermittedItems: [
          'Copy or exploit the system for unauthorized commercial purposes',
          'Copy software or system interface',
          'Use the Web App to develop competitive products.',
        ],
      },
      section3: {
        title: '3. User Account',
        content: 'In some cases, users may need to create an account to save designs or place orders.',
        responsible: 'Users are responsible for:',
        responsibleItems: [
          'Protecting account information',
          'Ensuring accuracy of provided information',
          'All activities arising from their account',
        ],
        footer: 'Fitta reserves the right to suspend or terminate accounts if violations are detected.',
      },
    },
  },
  termsAndConditions: {
    vi: {
      title: 'Điều khoản và chính sách',
      items: [
        {
          title: 'Chính sách bảo mật thông tin',
          content: [
            { title: 'Chúng tôi cam kết bảo vệ thông tin cá nhân của khách hàng.', content: '' },
            { title: 'Mọi dữ liệu thu thập chỉ được sử dụng để cải thiện trải nghiệm người dùng và không chia sẻ với bên thứ ba nếu không có sự đồng ý.', content: '' },
            { title: 'Khách hàng có quyền yêu cầu chỉnh sửa hoặc xóa thông tin cá nhân bất kỳ lúc nào.', content: '' },
          ],
        },
        {
          title: 'Chính sách thanh toán',
          content: [
            { title: 'Chúng tôi hỗ trợ các hình thức thanh toán: chuyển khoản ngân hàng, ví điện tử và thẻ tín dụng.', content: '' },
            { title: 'Tất cả giao dịch đều được mã hóa và bảo mật theo tiêu chuẩn quốc tế.', content: '' },
            { title: 'Trong trường hợp thanh toán không thành công, vui lòng liên hệ bộ phận hỗ trợ để được xử lý nhanh chóng.', content: '' },
          ],
        },
        {
          title: 'Chính sách giao hàng',
          content: [
            { title: 'Thời gian giao hàng từ 2–5 ngày làm việc tùy khu vực.', content: '' },
            { title: 'Miễn phí vận chuyển cho đơn hàng từ 500.000đ trở lên (áp dụng nội thành).', content: '' },
            { title: 'Khách hàng có thể theo dõi đơn hàng qua mã vận đơn được cung cấp sau khi xác nhận.', content: '' },
          ],
        },
        {
          title: 'Chính sách đổi trả và hoàn tiền',
          content: [
            { title: 'Sản phẩm được đổi trả trong vòng 7 ngày nếu có lỗi kỹ thuật hoặc không đúng mô tả.', content: '' },
            { title: 'Sản phẩm phải còn nguyên tem, nhãn và chưa qua sử dụng.', content: '' },
            { title: 'Hoàn tiền sẽ được xử lý trong vòng 5–7 ngày làm việc sau khi xác nhận.', content: '' },
          ],
        },
        {
          title: 'Chính sách bảo hành',
          content: [
            { title: 'Thời gian bảo hành tùy thuộc vào từng loại sản phẩm, thường từ 3–12 tháng.', content: '' },
            { title: 'Bảo hành chỉ áp dụng cho lỗi kỹ thuật từ nhà sản xuất, không bao gồm hao mòn tự nhiên hoặc lỗi do người dùng.', content: '' },
          ],
        },
        {
          title: 'Điều khoản sử dụng',
          content: [
            { title: 'Khi sử dụng dịch vụ/sản phẩm của chúng tôi, khách hàng đồng ý tuân thủ các quy định được nêu trong trang này.', content: '' },
            { title: 'Chúng tôi có quyền cập nhật chính sách mà không cần thông báo trước. Mọi thay đổi sẽ được đăng tải công khai tại đây.', content: '' },
          ],
        },
      ],
    },
    en: {
      title: 'Terms and Conditions',
      items: [
        {
          title: 'Information Privacy Policy',
          content: [
            { title: 'We are committed to protecting customer personal information.', content: '' },
            { title: 'All collected data is used only to improve user experience and is not shared with third parties without consent.', content: '' },
            { title: 'Customers have the right to request modification or deletion of personal information at any time.', content: '' },
          ],
        },
        {
          title: 'Payment Policy',
          content: [
            { title: 'We support payment methods: bank transfer, e-wallet, and credit card.', content: '' },
            { title: 'All transactions are encrypted and secured according to international standards.', content: '' },
            { title: 'In case of failed payment, please contact support for prompt resolution.', content: '' },
          ],
        },
        {
          title: 'Delivery Policy',
          content: [
            { title: 'Delivery time is 2–5 business days depending on region.', content: '' },
            { title: 'Free shipping for orders from 500,000đ and above (applies within city).', content: '' },
            { title: 'Customers can track orders via tracking number provided after confirmation.', content: '' },
          ],
        },
        {
          title: 'Return and Refund Policy',
          content: [
            { title: 'Products can be exchanged within 7 days if defective or not as described.', content: '' },
            { title: 'Product must retain original tags, labels, and be unused.', content: '' },
            { title: 'Refunds will be processed within 5–7 business days after confirmation.', content: '' },
          ],
        },
        {
          title: 'Warranty Policy',
          content: [
            { title: 'Warranty period depends on product type, typically 3–12 months.', content: '' },
            { title: 'Warranty applies only to manufacturer defects, excluding normal wear or user damage.', content: '' },
          ],
        },
        {
          title: 'Terms of Use',
          content: [
            { title: 'By using our services/products, customers agree to comply with regulations stated on this page.', content: '' },
            { title: 'We reserve the right to update policies without prior notice. All changes will be publicly posted here.', content: '' },
          ],
        },
      ],
    },
  },
  privacyPolicy: {
    vi: {
      title: 'Chính sách bảo mật thông tin',
      description: 'Chúng tôi cam kết tôn trọng và bảo vệ quyền riêng tư của khách hàng khi truy cập và sử dụng website, ứng dụng và các dịch vụ liên quan của Fitta. Chính sách này giải thích cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ thông tin cá nhân của khách hàng.',
      section1: {
        title: '1. Thông tin chúng tôi thu thập',
        content: 'Chúng tôi thu thập các loại thông tin sau:',
        items: [
          'Thông tin cá nhân (họ tên, email, số điện thoại)',
          'Địa chỉ giao hàng',
          'Thông tin thanh toán',
          'Lịch sử mua sắm',
          'Dữ liệu hoạt động trên website/ứng dụng',
        ],
      },
      section2: {
        title: '2. Cách chúng tôi sử dụng thông tin',
        content: 'Thông tin của khách hàng được sử dụng cho các mục đích:',
        items: [
          'Xử lý đơn hàng và giao hàng',
          'Cải thiện dịch vụ và trải nghiệm người dùng',
          'Gửi thông báo về đơn hàng hoặc cập nhật dịch vụ',
          'Phân tích dữ liệu để tối ưu hóa nền tảng',
          'Tuân thủ các yêu cầu pháp lý',
        ],
      },
      section3: {
        title: '3. Bảo vệ thông tin cá nhân',
        content: 'Chúng tôi cam kết bảo vệ thông tin cá nhân của khách hàng thông qua:',
        items: [
          'Mã hóa dữ liệu (SSL/TLS)',
          'Kiểm soát truy cập nghiêm ngặt',
          'Nền tảng lưu trữ an toàn',
          'Kiểm toán bảo mật định kỳ',
        ],
      },
      section4: {
        title: '4. Chia sẻ thông tin',
        content: 'Fitta không chia sẻ thông tin cá nhân của khách hàng với bên thứ ba ngoại trừ trong các trường hợp sau:',
        items: [
          'Các đối tác giao vận (để xử lý giao hàng)',
          'Nhà cung cấp dịch vụ thanh toán',
          'Tuân thủ yêu cầu từ cơ quan pháp luật',
        ],
        footer: 'Mọi bên thứ ba được yêu cầu tuân thủ các tiêu chuẩn bảo vệ dữ liệu tương tự như Fitta.',
      },
      section5: {
        title: '5. Quyền của khách hàng',
        content: 'Khách hàng có quyền:',
        items: [
          'Truy cập thông tin cá nhân của mình',
          'Yêu cầu chỉnh sửa thông tin không chính xác',
          'Yêu cầu xóa thông tin cá nhân',
          'Hủy theo dõi/nhận email quảng cáo',
        ],
        footer: 'Để thực hiện các quyền này, khách hàng vui lòng liên hệ với chúng tôi qua email hoặc hotline.',
      },
      section6: {
        title: '6. Cookie và công nghệ theo dõi',
        content: 'Website/ứng dụng của Fitta sử dụng cookie để cải thiện trải nghiệm người dùng. Khách hàng có thể vô hiệu hóa cookie thông qua cài đặt trình duyệt, nhưng điều này có thể ảnh hưởng đến tính năng của website.',
      },
      section7: {
        title: '7. Liên hệ với chúng tôi',
        content: 'Nếu có câu hỏi về chính sách bảo mật, khách hàng vui lòng liên hệ:',
        items: [
          'Email: lanhainfo@gmail.com',
          'Hotline: {{phone}}',
          'Thời gian hỗ trợ: 8h00–17h30 từ thứ Hai đến thứ Bảy',
        ],
      },
    },
    en: {
      title: 'Privacy Policy',
      description: 'We are committed to respecting and protecting the privacy of customers accessing and using Fitta\'s website, application, and related services. This policy explains how we collect, use, store, and protect customers\' personal information.',
      section1: {
        title: '1. Information We Collect',
        content: 'We collect the following types of information:',
        items: [
          'Personal information (full name, email, phone number)',
          'Delivery address',
          'Payment information',
          'Purchase history',
          'Activity data on the website/application',
        ],
      },
      section2: {
        title: '2. How We Use Information',
        content: 'Customer information is used for the following purposes:',
        items: [
          'Processing orders and delivery',
          'Improving services and user experience',
          'Sending order notifications or service updates',
          'Analyzing data to optimize the platform',
          'Complying with legal requirements',
        ],
      },
      section3: {
        title: '3. Protecting Personal Information',
        content: 'We are committed to protecting customer personal information through:',
        items: [
          'Data encryption (SSL/TLS)',
          'Strict access control',
          'Secure storage platform',
          'Regular security audits',
        ],
      },
      section4: {
        title: '4. Information Sharing',
        content: 'Fitta does not share customer personal information with third parties except in the following cases:',
        items: [
          'Logistics partners (to process delivery)',
          'Payment service providers',
          'Compliance with requests from legal authorities',
        ],
        footer: 'All third parties are required to comply with data protection standards similar to Fitta\'s.',
      },
      section5: {
        title: '5. Customer Rights',
        content: 'Customers have the right to:',
        items: [
          'Access their personal information',
          'Request correction of inaccurate information',
          'Request deletion of personal information',
          'Unsubscribe from/opt out of receiving promotional emails',
        ],
        footer: 'To exercise these rights, customers please contact us via email or hotline.',
      },
      section6: {
        title: '6. Cookies and Tracking Technologies',
        content: 'Fitta\'s website/application uses cookies to improve user experience. Customers can disable cookies through browser settings, but this may affect website functionality.',
      },
      section7: {
        title: '7. Contact Us',
        content: 'If you have questions about the privacy policy, please contact:',
        items: [
          'Email: lanhainfo@gmail.com',
          'Hotline: {{phone}}',
          'Support hours: 8:00 AM–5:30 PM, Monday to Saturday',
        ],
      },
    },
  },
};
